import React, { useCallback } from 'react';
import './StoreQRPosters.css';
import QRPosterCard from '../components/QRPosterCard';
import EmptyState from '../../../shared/components/ui/EmptyState';
import { QrCode } from 'lucide-react';

const StoreQRPosters = ({ sections = [], storeProfile, onToast }) => {
  const storeName = storeProfile?.storeName || '';
  const storeUuid = storeProfile?.storeUuid || '';

  const buildQueueUrl = useCallback((section) => {
    return `${window.location.origin}/queue?store=${storeUuid}&section=${section?.sectionUuid || ''}`;
  }, [storeUuid]);

  const handleDownload = useCallback((section) => {
    const sectionName = section?.sectionName || section?.name || 'poster';
    const url = buildQueueUrl(section);

    const printWindow = window.open('', '_blank');
    if (!printWindow) {
      onToast?.({ message: 'Please allow popups to download the poster.', variant: 'info' });
      return;
    }
    printWindow.document.write(`
      <html>
        <head><title>${sectionName} - QR Poster</title>
        <style>
          body { margin: 0; display: flex; align-items: center; justify-content: center; min-height: 100vh; background: #080808; font-family: system-ui, sans-serif; }
          .poster { text-align: center; padding: 48px; color: #fff; }
          .store-name { font-size: 12px; font-weight: 700; text-transform: uppercase; letter-spacing: 2px; color: #7a7a7a; margin-bottom: 24px; }
          .qr-area { width: 200px; height: 200px; background: #fff; border-radius: 16px; margin: 0 auto 24px; display: flex; align-items: center; justify-content: center; }
          .qr-area img { width: 180px; height: 180px; }
          .section-name { font-size: 24px; font-weight: 700; margin-bottom: 8px; }
          .subtitle { font-size: 13px; color: #9aa4b2; }
          .url { font-size: 10px; color: #555; margin-top: 16px; word-break: break-all; }
          @media print { body { background: #fff; } .poster { color: #000; } .store-name, .subtitle { color: #555; } }
        </style></head>
        <body>
          <div class="poster">
            <div class="store-name">${storeName}</div>
            <div class="qr-area">
              <img src="https://api.qrserver.com/v1/create-qr-code/?size=180x180&data=${encodeURIComponent(url)}" alt="QR Code" />
            </div>
            <div class="section-name">${sectionName}</div>
            <div class="subtitle">Scan to join queue</div>
            <div class="url">${url}</div>
          </div>
        </body>
      </html>
    `);
    printWindow.document.close();
    setTimeout(() => printWindow.print(), 600);
  }, [buildQueueUrl, storeName, onToast]);

  if (!sections.length) {
    return (
      <EmptyState
        icon={<QrCode size={20} />}
        title="No QR Posters"
        description="Create sections first — each section gets its own QR poster for customers to scan and join."
      />
    );
  }

  return (
    <div className="qr-posters-page">
      <div className="qr-posters-page__header">
        <div className="qr-posters-page__header-left">
          <h2>QR Posters</h2>
          <p>{sections.length} poster{sections.length !== 1 ? 's' : ''} available</p>
        </div>
      </div>

      <div className="qr-posters-page__grid">
        {sections.map((section, index) => (
          <QRPosterCard
            key={section.sectionUuid || index}
            section={section}
            storeName={storeName}
            qrValue={buildQueueUrl(section)}
            index={index}
            onDownload={handleDownload}
          />
        ))}
      </div>
    </div>
  );
};

export default StoreQRPosters;
